(function () {
    'use strict';

    const storageKey = 'dash-theme';

    function getPreferredTheme() {
        const savedTheme = localStorage.getItem(storageKey);

        if (savedTheme === 'light' || savedTheme === 'dark') {
            return savedTheme;
        }

        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    function applyTheme(theme) {
        document.documentElement.setAttribute('data-bs-theme', theme);
        updateToggleUi(theme);
    }

    function updateToggleUi(theme) {
        const icon = document.getElementById('themeToggleIcon');
        const text = document.getElementById('themeToggleText');
        const button = document.getElementById('themeToggleBtn');

        if (!icon || !text || !button) {
            return;
        }

        if (theme === 'dark') {
            icon.className = 'bi bi-sun-fill';
            text.textContent = 'Day';
            button.setAttribute('aria-label', 'Switch to day mode');
            button.setAttribute('title', 'Switch to day mode');
        } else {
            icon.className = 'bi bi-moon-stars-fill';
            text.textContent = 'Night';
            button.setAttribute('aria-label', 'Switch to night mode');
            button.setAttribute('title', 'Switch to night mode');
        }
    }

    function toggleTheme() {
        const currentTheme = document.documentElement.getAttribute('data-bs-theme') || 'light';
        const nextTheme = currentTheme === 'dark' ? 'light' : 'dark';

        localStorage.setItem(storageKey, nextTheme);
        applyTheme(nextTheme);
    }

    function bindThemeToggle() {
        const button = document.getElementById('themeToggleBtn');

        if (!button) {
            return;
        }

        button.addEventListener('click', toggleTheme);
    }

    document.addEventListener('DOMContentLoaded', function () {
        applyTheme(getPreferredTheme());
        bindThemeToggle();
    });
})();